import type { KioskRegistrationStatus } from '../../types/kioskRegistration.types';
import { STATUS_LABELS, STATUS_STYLES } from './registrationUi';

export default function RegistrationStatusBadge({
  status,
  channelDeleted = false,
}: {
  status: KioskRegistrationStatus;
  channelDeleted?: boolean;
}) {
  if (channelDeleted) {
    return (
      <span
        title="The channel created by this registration has been deleted"
        className="inline-flex whitespace-nowrap rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-800 dark:bg-red-900/40 dark:text-red-200"
      >
        Channel deleted
      </span>
    );
  }
  return (
    <span
      className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_STYLES[status] ?? STATUS_STYLES.CANCELLED}`}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
